export default "__VITE_ASSET__Ds3eTPsF__"